// Whose note is it? Pure and import-free so the Worker's suite can load it.
//
// U4.2: `app_notes` select is `user_id = auth.uid() or is_admin()` (U0.2), so
// an admin's `useNotes()` already holds everyone's rows and a non-admin's holds
// only their own — Postgres decides, the query does not branch. That is on
// purpose: a second query key for "admin" would split the cache the optimistic
// patches in `mutations.ts` write to by exact key. What the client adds is a
// label, and a rule about which rows it may reword or delete.

/** How many characters of a `user_id` stand in for a name. */
export const AUTHOR_LEN = 8

/**
 * A note is "mine" when it is mine by id, or when either id is unknown (an
 * optimistic row, one cached before the column was read, a session still
 * resolving) — the unknown case must stay editable, or a fresh note would lock
 * its own writer out until the refetch.
 */
export const isOwnNote = (noteUserId: string | null | undefined, myUserId: string | null | undefined): boolean =>
  !noteUserId || !myUserId || noteUserId === myUserId

/**
 * The author tag for a note that is not mine, else null.
 *
 * FUTURE: the first eight characters of the `user_id`, and nothing friendlier,
 * because `profiles` RLS is own-row only — an admin cannot read another
 * person's `display_name` through the client (U1.1). When an admin-readable
 * name exists (a `security definer` view or RPC returning `display_name` for
 * admins), swap it in here and nowhere else.
 */
export const noteAuthor = (noteUserId: string | null | undefined, myUserId: string | null | undefined): string | null =>
  isOwnNote(noteUserId, myUserId) ? null : noteUserId!.slice(0, AUTHOR_LEN)
